const resource = 'autoways-lookups'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  myHistory(params) {
    return $axios.$get(`/${resource}/my-history`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  delete(id) {
    return $axios.$delete(`/${resource}/${id}`)
  },
  removeUser(id) {
    return $axios.$patch(`/${resource}/${id}/remove_user`)
  },

  getServiceName: name => 'autowaysLookupService',
})
